import { H5PPlayerUI } from "@lumieducation/h5p-react";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { viewContent } from "../../../api";
import HeaderPage from "../../../layouts/Header/HeaderPage/HeaderPage";
import NavContent from "../../../layouts/NavContent/NavContent";
import { common } from "../../../utils/common";
import parseJwt from "../../../funtions/parseJwt";
import { useAppContext } from "../../../context/AppContext";


// Theo doi tien do XEM video trong H5P (Interactive Video / video) - coverage theo giay,
// gui ra trang cha (Canvas theme) qua postMessage de tinh watch-time + %xem.
function startH5PVideoWatch(contentId) {
  var TICK = 5, buckets = {}, sent = 0, lastT = -1, lastFound = null;
  function wins() {
    var ws = [window];
    document.querySelectorAll("iframe").forEach(function (fr) {
      try { if (fr.contentWindow && fr.contentWindow.document) ws.push(fr.contentWindow); } catch (e) {}
    });
    return ws;
  }
  function info() {
    var list = wins();
    for (var i = 0; i < list.length; i++) {
      var W = list[i];
      // 1) H5P instance API (chuan nhat, ho tro ca HTML5 + YouTube)
      try {
        var H = W.H5P;
        if (H && H.instances) {
          for (var k = 0; k < H.instances.length; k++) {
            var inst = H.instances[k];
            var vid = inst && (inst.video || (inst.interactiveVideo && inst.interactiveVideo.video));
            if (vid && vid.getCurrentTime && vid.getDuration) {
              var d = vid.getDuration(), t = vid.getCurrentTime();
              if (d > 0) return { t: t, d: d, src: "h5p-instance" };
            }
          }
        }
      } catch (e) {}
      // 2) <video> element
      try {
        var v = W.document.querySelector("video");
        if (v && isFinite(v.duration) && v.duration > 0)
          return { t: v.currentTime, d: v.duration, paused: v.paused, seeking: v.seeking, src: "video-el" };
      } catch (e) {}
    }
    return null;
  }
  function dbg(payload) { try { window.parent.postMessage(Object.assign({ source: "h5p-video-debug", contentId: contentId }, payload), "*"); } catch (e) {} }
  var iv = setInterval(function () {
    var d = info();
    var foundHow = d ? d.src : null;
    if (foundHow !== lastFound) { lastFound = foundHow; dbg({ found: !!d, how: foundHow }); }
    if (!d) return;
    if (d.t >= lastT && (d.t - lastT) < 3 && d.paused !== true && d.seeking !== true) buckets[Math.floor(d.t / TICK)] = 1;
    lastT = d.t;
    var watched = Math.min(Object.keys(buckets).length * TICK, Math.round(d.d));
    var pct = Math.min(100, Math.round((watched / d.d) * 100));
    var now = Date.now(); if (now - sent < 3000) return; sent = now;
    var msg = { source: "h5p-video", contentId: contentId, video_pct: pct, watched_seconds: watched, position: Math.round(d.t), duration: Math.round(d.d) };
    try { if (window.parent) window.parent.postMessage(msg, "*"); } catch (e) {}
    try { if (window.top && window.top !== window.parent) window.top.postMessage(msg, "*"); } catch (e) {}
  }, 1000);
  setTimeout(function () { clearInterval(iv); }, 6 * 3600 * 1000);
}

export default function ViewContent() {
  const h5pPlayer = useRef();
  const { id } = useParams();
  const [content_id, setContentId] = useState("");
  const { userInfo, setUserInfo } = useAppContext();

  useEffect(() => {
    const JWT_loginToken = common.getToken();
    const json = parseJwt(JWT_loginToken);
    setUserInfo(json);
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get("id");
    if (value) setContentId(value);
    else {
      setContentId(id);
    }
  }, []);

  const getEdit = async () => {
    if (content_id) {
      const res = await viewContent(content_id);
      try {
        window.parent.postMessage(JSON.stringify(res.data), "*");
        // window.parent.parent.postMessage(JSON.stringify(res.data),"*");
      } catch (error) {
        console.log(error)
      }
      
      return res.data;
    }
  };

  return (
    <div className={id ? "lti" : "manage-content"}>
      {common.getLtiLMS() ? <></> : <HeaderPage />}
      {content_id && (
        <>
          {/* //NavContent chỉ hiển thị khi khác roleName là 'Learner' và khác undefined */}
          {userInfo.roleName !== "Learner" && userInfo.roleName !== undefined && (
            <NavContent
              view={true}
              edit="1"
              folder={id ? false : "1"}
              // option="1"
              contentId={content_id}
            />
          )}

          <div className={`content-area${id && userInfo.roleName !== "Learner"? "-author" : id? "-leaner" : ""}`}>

            <H5PPlayerUI
              ref={h5pPlayer}
              contentId={content_id}
              loadContentCallback={getEdit}
              onInitialized={() => startH5PVideoWatch(content_id)}
              onxAPIStatement={(statement, context, event) => {
                try {
                  var msg = { source: "h5p-xapi", contentId: content_id, statement: statement };
                  if (window.parent) window.parent.postMessage(msg, "*");
                  if (window.top && window.top !== window.parent) window.top.postMessage(msg, "*");
                } catch (e) {}
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
